import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { Div } from '../../layouts';

const waves = keyframes`
  0% { transform: translate3d(-100%, 0, 0); }
  100% { transform: translate3d(100%, 0, 0); }
`;

export const getLocationsListSkeleton = ({
    borderRadius = '5px',
    height = '22px',
    width = '60%',
}) => styled(Div, {
    shouldForwardProp,
})`
    height: ${height};
    box-sizing: border-box;
    min-width: 0;
    width: ${width};
    background-color: rgb(230, 230, 230);
    position: relative;
    overflow: hidden;
    border-radius: ${borderRadius};
    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to right, rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.4) 20%, rgba(255, 255, 255, 0.6) 50%,
            rgba(255, 255, 255, 0.4) 80%, rgba(255, 255, 255, 0) 100%);
        animation: ${waves} 1s ease-in-out infinite;

    }
`;
